import { connect } from 'react-redux'
import { showAlert } from '../utils/Alert'
import {
  putUserSettings,
  setUserSettings,
  openTrainSelectModal,
} from '../actions'
import TrainPositionsApp from '../components/train_positions/TrainPositionsApp'
import { createCommonActionCreators } from './helpers/trainActionCreators'
import { processTrains } from './helpers/trainUtils'

const mapStateToProps = state => {
  const { updatedAt, jrLocationUpdatedAt } = state.trainPositionReducer
  const { themeName } = state.themeReducer
  const { trainPositionAutoRefresh, popinfoId } = state.userSettingsReducer
  const { appVersion } = state.appVersionReducer
  const trains = processTrains(state.trainPositionReducer.trains)

  return {
    trains,
    updatedAt,
    jrLocationUpdatedAt,
    themeName,
    trainPositionAutoRefresh,
    popinfoId,
    appVersion,
  }
}

const mapDispatchToProps = (dispatch) => {
  const commonActions = createCommonActionCreators(dispatch)

  return {
    ...commonActions,
    changeTrainPositionAutoRefresh: async (popinfoId, enableAutoRefresh) => {
      try {
        const payload = {
          'train_position_auto_refresh': enableAutoRefresh
        }
        if (popinfoId) {
          await putUserSettings(popinfoId, payload)
        }
        dispatch(setUserSettings(payload))
      } catch (error) {
        showAlert('設定を更新できませんでした')
      }
    },
    openTrainSelectModal: (selectingTrains) => {
      dispatch(openTrainSelectModal(selectingTrains))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrainPositionsApp)
